import { useAuth } from "components/utils/auth";
import { JobManagementApi } from "components/utils/openapi";
import { AppConfig, getDefaultOptions } from "core/AppConfig";
import { useMutation } from "react-query";

export const useBuildBundleDownload = () => {
  const { getToken } = useAuth();
  return useMutation(async ({buildBundleId, buildBundleType}: {buildBundleId: string, buildBundleType: string}) => {
    const { getConfiguration } = AppConfig();
    const token = await getToken();
    const api = new JobManagementApi(getConfiguration(token));
    return api.buildBundlesControllerDownload(
      buildBundleId,
      buildBundleType,
      getDefaultOptions(token)
    );
  });
};
